import { createStyles } from 'antd-style'

export const useStyle = createStyles(
  (
    _,
    props: {
      height?: number
    }
  ) => ({
    skeleton: {
      '.ant-skeleton-input': {
        minHeight: `${props?.height || 16}px`
      }
    }
  })
)
